import { Component } from '@theme/component';

/**
 * A product highlight card component used in the custom search overlay.
 *
 * @extends {Component}
 */
class SearchProductCard extends Component {}

if (!customElements.get('search-product-card')) {
  customElements.define('search-product-card', SearchProductCard);
}
